import React from 'react'
import Translation from "../../Translation/cont/Translation"
import Button from "../../general/Button"
import OverlayWrapper from "./OverlayWrapper"

const OverlaySaveProgramComponent = ({
    titleTransId, 
    textTransId, 
    buttonPublishTransId, 
    buttonGetTransId, 
    onGetProgram, 
    onUpdateProgram
}) => (
    <OverlayWrapper>
        <div className='title-large-color text'><Translation id={titleTransId}/></div>
        <p className="text-large-light text"><Translation id={textTransId}/></p>

        <div className="buttons-submit-cancel">
            <Button
                className="button-submit"
                transId={buttonGetTransId}
                onClick={onGetProgram}
                disabled={false}
                hideText={false}
                type="submit"
            />
            <Button
                className="button-submit"
                transId={buttonPublishTransId}
                onClick={onUpdateProgram}
                disabled={false}
                hideText={false}
                type="submit"
            />

        </div>
    </OverlayWrapper>
)

export default OverlaySaveProgramComponent